import moment from 'moment'

export function formatDate (dateString, format) {
  return moment(dateString, format).format('DD.MM.YYYY')
}

export const egnValidator = {
  getMessage () {
    return 'Невалидно ЕГН'
  },

  validate (value) {
    return checkEGN(value)
  }
}

function checkEGN (egn) {
  // check length
  if (egn.length !== 10) {
    return false
  }

  let weights = [2, 4, 8, 5, 10, 9, 7, 3, 6]
  let year = parseInt(egn.substr(0, 2))
  let month = parseInt(egn.substr(2, 2))
  let day = parseInt(egn.substr(4, 2))
  let checksum = parseInt(egn.substr(9, 1))

  if (month > 40) {
    month -= 40
    year += 2000
  } else if (month > 20) {
    month -= 20
    year += 1800
  } else {
    year += 1900
  }

  // check date
  if (!moment([year, month - 1, day]).isValid()) {
    return false
  }

  // calculate EGN checksum
  let egnSum = 0
  for (let i = 0; i < 9; i++) {
    egnSum += parseInt(egn.substr(i, 1)) * weights[i]
  }

  let validChecksum = egnSum % 11
  if (validChecksum === 10) {
    validChecksum = 0
  }

  // compare checksum
  return checksum === validChecksum
}

export function sortByName (a, b) {
  if (a.name < b.name) {
    return -1
  } else if (a.name > b.name) {
    return 1
  } else {
    return 0
  }
}
